import { BRAND } from "../../data/site";
import { Instagram } from "lucide-react";

export const Footer = () => {
    return (
        <footer data-testid="site-footer" className="border-t border-[#262626] bg-black py-12">
            <div className="max-w-7xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-6">
                <a href="#top" data-testid="footer-logo" className="flex items-center gap-3">
                    <img src={BRAND.logo} alt={BRAND.name} className="h-9 w-9 object-cover rounded-sm" />
                    <span className="font-display font-bold uppercase tracking-tight text-white">
                        HYPE <span className="text-[#E60000]">SNEAKERS</span> 21
                    </span>
                </a>
                <a
                    href={BRAND.instagramUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-instagram-link"
                    className="flex items-center gap-2 text-sm text-neutral-400 hover:text-white transition-colors"
                >
                    <Instagram className="h-4 w-4" /> {BRAND.instagramHandle}
                </a>
                <p className="text-xs text-neutral-500">
                    © 2021 {BRAND.name}. Tutti i diritti riservati.
                </p>
            </div>
        </footer>
    );
};
